// extracted by mini-css-extract-plugin
export default {"attachmentContainer":"styles_attachmentContainer__AwmP-","attachmentItem":"styles_attachmentItem__SDAPG","fileLink":"styles_fileLink__DKtzJ"};